// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1LNXN","outer-revamp":"_2P0zD"};